import UICheckbox from 'UIComponents/input/UICheckbox';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITruncateString from 'UIComponents/text/UITruncateString';
import PortalIdParser from 'PortalIdParser';
// @ts-expect-error untyped module
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { useGetHasScope } from 'automation-ui-core/hooks/authHooks';
import { CONTACT_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import ObjectNameReference from 'automation-ui-enrollment/components/filters/enrollment/generic-enrollment-table/ObjectNameReference';
import { MARKETABLE_CONTACTS_ACCESS } from 'automation-ui-enrollment/constants/Scopes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TableCheckboxCell = ({
  rowIndex,
  allObjectPropertiesResults,
  checkedItems,
  onSelectObject,
  isMultiSelect
}) => {
  const Component = isMultiSelect ? UICheckbox : UIRadioInput;
  const objectProperties = allObjectPropertiesResults[rowIndex] && allObjectPropertiesResults[rowIndex].properties;
  if (objectProperties) {
    return /*#__PURE__*/_jsx(Component, {
      checked: checkedItems && checkedItems.has(objectProperties.hs_object_id.value),
      onChange: ({
        target: {
          checked
        }
      }) => {
        onSelectObject({
          objectId: objectProperties.hs_object_id.value,
          shouldEnroll: checked
        });
      }
    });
  }
  return null;
};
export const TableObjectNameCell = ({
  rowIndex,
  rowConfig,
  objectTypeId,
  allObjectPropertiesResults
}) => {
  const objectProperties = allObjectPropertiesResults[rowIndex] && allObjectPropertiesResults[rowIndex].properties;
  const hasScope = useGetHasScope();
  const showNonMarketingStatus = hasScope(MARKETABLE_CONTACTS_ACCESS) && objectTypeId === CONTACT_ID;
  const marketingContact = objectProperties && objectProperties.hs_marketable_status && objectProperties.hs_marketable_status.value === 'true';
  if (objectProperties) {
    return /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      children: [rowConfig && rowConfig.avatar && /*#__PURE__*/_jsx(UIAvatar, {
        vid: Number(objectProperties && objectProperties.hs_object_id.value),
        className: "m-right-3",
        portalId: PortalIdParser.get()
      }), /*#__PURE__*/_jsx(UITruncateString, {
        children: /*#__PURE__*/_jsx(ObjectNameReference, {
          id: objectProperties && objectProperties.hs_object_id.value,
          objectTypeId: objectTypeId,
          showNonMarketingStatus: showNonMarketingStatus && !marketingContact
        })
      })]
    });
  }
  return null;
};
export const TableCustomObjectDataCell = ({
  rowIndex,
  property,
  allObjectPropertiesResults
}) => {
  const objectProperties = allObjectPropertiesResults[rowIndex] && allObjectPropertiesResults[rowIndex].properties;
  if (objectProperties) {
    return /*#__PURE__*/_jsx(UITruncateString, {
      children: objectProperties[property] && objectProperties[property].value
    });
  }
  return null;
};
export const TableObjectDataCell = ({
  rowIndex,
  rowLabelCreator,
  allObjectPropertiesResults
}) => {
  const objectProperties = allObjectPropertiesResults[rowIndex] && allObjectPropertiesResults[rowIndex].properties;
  if (objectProperties) {
    return /*#__PURE__*/_jsx(UITruncateString, {
      children: rowLabelCreator(objectProperties)
    });
  }
  return null;
};